import type { HFetchArgs } from './types';

export const makeRequest = async <B>({ url, method = 'GET', payload }: HFetchArgs<B>) => {
  return await fetch(url, {
    method,
    headers: buildHeaders(payload),
    ...buildBody(payload),
  });
};

const buildHeaders = <B>(payload?: B) => {
  const headers: HeadersInit = {};

  if (!(payload instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
  }

  const csrfToken = document.querySelectorAll('[name="csrf-token"]')[0];
  if (csrfToken && csrfToken instanceof HTMLMetaElement) {
    headers['X-CSRF-TOKEN'] = csrfToken.content;
  }

  return headers;
};

const buildBody = <B>(payload?: B) => {
  if (payload) return { body: payload instanceof FormData ? payload : JSON.stringify(payload) };
  return {};
};
